/*
 * FG CONSULTATION OFFER - countdown + cart sync module.
 * Loaded by snippets/fg-consultation-config.liquid (only when the offer is on).
 * Built 11 September 2026 (consultation offer project).
 *
 * Responsibilities:
 * 1. Tick the countdown displays (per-minute long form on the product page,
 *    per-second compact form in the cart drawer). Hide every offer element
 *    when the deadline passes. The deadline is a fixed date in Europe/London,
 *    never a per-visitor timer.
 * 2. Keep the free consultation line item in sync with the cart: present
 *    exactly once while an eligible kit is in the cart, absent otherwise.
 *    Uses the theme's own events: listens to `cart:change`, and dispatches
 *    `cart:refresh` after its own writes so the theme re-renders the drawer.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('fg-consultation-config');
  if (!cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* ------------------------------------------------ countdown ------- */

  function londonOffsetMinutes(date) {
    var dtf = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    var p = {};
    dtf.formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
    var asUTC = Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second);
    return (asUTC - date.getTime()) / 60000;
  }

  function parseDeadline(str) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(str || '');
    if (!m) return null;
    var utcGuess = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    var off = londonOffsetMinutes(new Date(utcGuess));
    var ts = utcGuess - off * 60000;
    var off2 = londonOffsetMinutes(new Date(ts));
    if (off2 !== off) ts = utcGuess - off2 * 60000;
    return ts;
  }

  var deadlineTs = cfg.mode === 'countdown' ? parseDeadline(cfg.deadline) : null;
  var expired = false;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function fmtLong(ms) {
    var mins = Math.floor(ms / 60000);
    var d = Math.floor(mins / 1440);
    var h = Math.floor((mins % 1440) / 60);
    var mm = mins % 60;
    var parts = [];
    if (d > 0) parts.push(d + (d === 1 ? ' day' : ' days'));
    parts.push(h + (h === 1 ? ' hr' : ' hrs'));
    parts.push(mm + (mm === 1 ? ' min' : ' mins'));
    return parts.join(' ');
  }

  function fmtCompact(ms) {
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var ss = s % 60;
    return (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(ss);
  }

  function hideAll() {
    document.querySelectorAll('[data-fg-consultation]').forEach(function (el) {
      el.hidden = true;
      el.style.display = 'none';
    });
  }

  function tick() {
    if (deadlineTs == null) return;
    var ms = deadlineTs - Date.now();
    if (ms <= 0) {
      if (!expired) { expired = true; hideAll(); }
      return;
    }
    document.querySelectorAll('[data-fg-countdown="long"]').forEach(function (el) {
      el.textContent = ' — ' + fmtLong(ms) + ' left';
    });
    document.querySelectorAll('[data-fg-countdown="compact"]').forEach(function (el) {
      el.textContent = ' (' + fmtCompact(ms) + ' left)';
    });
  }

  if (deadlineTs != null) {
    tick();
    setInterval(tick, 1000);
  }

  /* ------------------------------------------------- cart sync ------ */

  var busy = false;

  function refreshTheme() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function sync(cart) {
    if (busy || !cfg.autoAdd || expired || !cart || !cart.items) return;

    var eligibleQty = 0;
    var consult = null;

    cart.items.forEach(function (item) {
      if (cfg.eligibleHandles.indexOf(item.handle) > -1) eligibleQty += item.quantity;
      if (item.variant_id === cfg.consultationVariantId) consult = item;
    });

    var req = null;

    if (eligibleQty > 0 && !consult) {
      req = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: cfg.consultationVariantId,
          quantity: 1,
          properties: { _fg_consultation: 'auto' }
        })
      });
    } else if (eligibleQty === 0 && consult) {
      req = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: consult.key, quantity: 0 })
      });
    } else if (consult && consult.quantity !== 1) {
      req = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: consult.key, quantity: 1 })
      });
    }

    if (req) {
      busy = true;
      req.then(function (r) { return r.json(); })
        .then(function () { busy = false; refreshTheme(); })
        .catch(function () { busy = false; });
    }
  }

  document.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.cart) sync(e.detail.cart);
  });

  function initialSync() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(sync)
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSync);
  } else {
    initialSync();
  }
})();
